import { ComponentType } from "react";
import styled from "styled-components";
import { globalTheme } from "@clds/component-theme";

export const StyledGridItemWrapper: ComponentType<any> = styled.div`
    margin-left: ${globalTheme.spacing.xl};

    li {
        list-style: none !important;
        padding-right: 0 !important;
        width: 100% !important;
    }
`;
